import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2DocumentAttachment } from '@/api/model/interfaces';

export default class PackageKS2DocumentAttachmentOdata extends OdataManager<PackageKS2DocumentAttachment> {}
